import Page from "../Shared/Page/Page";
import Feed from './Feed';
import HomePageActions from './HomePageActions';
import { useState } from "react";

import styles from "./home.module.scss";
import AddStoryDialog from "./AddStoryDialog";

export default function Home() {
	const [showStoryModal, setShowStoryModal] = useState(false);

	return (
		<Page
			title="Peer-Gaming"
			actions={
				<HomePageActions
					showModal={showStoryModal}
					setModal={setShowStoryModal}
				/>
			}
		>
			<div className={styles.root}>
				<Feed />
			</div>
			<AddStoryDialog
				showModal={showStoryModal}
				setShowModal={setShowStoryModal}
			/>
		</Page>
	);
}